import { render, staticRenderFns } from "./LaoPuBaseFloatingPC.vue?vue&type=template&id=3bae15a9"
import script from "./LaoPuBaseFloatingPC.vue?vue&type=script&setup=true&lang=js"
export * from "./LaoPuBaseFloatingPC.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports